



















































import {
  Component,
  Vue,
} from 'vue-property-decorator';

import DEMO_DATA from '@/demo-data';
import BrandSlideSection from '@/sections/BrandSlide.vue';
import CarouselSection from '@/sections/Carousel.vue';
import CollectionListSection from '@/sections/CollectionList.vue';
import FeaturedCollectionSection from '@/sections/FeaturedCollection.vue';
import InstagramEmbedSection from '@/sections/InstagramEmbed.vue';

@Component({
  components: {
    BrandSlideSection,
    CarouselSection,
    CollectionListSection,
    FeaturedCollectionSection,
    InstagramEmbedSection,
  },
})
export default class Home extends Vue {
  public readonly slides = DEMO_DATA.homeSlides;
  public readonly collections = DEMO_DATA.homeCollections;
  public readonly featuredCollections = DEMO_DATA.homeFeaturedCollections;
}
